<template>
  <div class="integration-status">
    <div class="integration-status__right">
      <VLabel :type="status">
        <template v-slot:text>
          {{ $t(`companySettings.integrations.status.${status}`) }}
        </template>
      </VLabel>
    </div>
  </div>
</template>

<script>
import VLabel from '@/components/deprecated/atoms/Label.vue';
import integrationsManagementMixin from '@/mixins/integrationsManagementMixin';

export default {
  name: 'VIntegrationStatus',
  components: {
    VLabel,
  },
  props: {
    integration: {
      type: [Object],
      required: true,
    },
  },
  mixins: [
    integrationsManagementMixin,
  ],
  computed: {
    status() {
      if (this.hasInstance) {
        return this.integration.instance.status;
      }

      return 'inactive';
    },
  },
};

</script>

<style scoped>
.integration-status__right {
  float: right;
}
.a-label {
  font-family: 'Roboto', sans-serif!important;
  margin: 0;
}
.a-label--inactive {
  background-color: var(--color-info);
}
.a-label--beta {
  background-color: var(--signable-secondary-2);
}
.a-label--unconfigured {
  background-color: var(--color-error);
}
.a-label--unauthorized {
  background-color: var(--color-error);
}
.a-label--configured {
  background-color: var(--color-success);
}
</style>
